import React, { Component } from 'react';
import { globalConstants } from "../../../constants/globalConstants";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import $ from 'jquery';
import GlobalStoreService from '../../../services/global-store.service'
import PopUp from '../../common-components/popup'
import PackBenefits from './packbenefits'
import ConfirmationBox from "../../common-components/confirmation-box.component";
import IdleTimeoutService from "../../../services/idle-timeout.service";
import UtilService from "../../../services/util.service"
import PlatformType from "../../../enums/PlatformType"
import { SCRIPTS } from "../../../constants/staticScripts";
import UserActionClass from '../../../objectClasses/user-action-class'
import UserActionType from '../../../enums/UserActionType'

const IrRecommendedPacks = (message, setBottomBarToInput, showPopup, handleUserAction) => {
    let { packDetails, chatItem, templateName, messageTime } = message
    // console.log(packDetails)
    try {
        packDetails = JSON.parse(packDetails)
    }
    catch (e) {
        packDetails = undefined
    }

    let irPackList = [];
    packDetails = packDetails.hasOwnProperty('IR Pack Details') ? packDetails['IR Pack Details'] : packDetails
    if (packDetails && packDetails.suggestedIRPack) {
        packDetails.suggestedIRPack['suggested_pack'] = true;
        irPackList.push(packDetails.suggestedIRPack);
    }
    if (packDetails && packDetails.otherIRPacks) {
        irPackList.push(...packDetails.otherIRPacks);
    }

    let isSubscribedAnyPack = false;
    let subscribedPack = {};

    for (let i = 0; i < irPackList.length; i++) {
        if (irPackList[i].subscribed && irPackList[i].subscribed === 'true') {
            isSubscribedAnyPack = true;
            subscribedPack = irPackList[i];
        }
    }
    const showMorePlans = () => {
        let monthly_plans = $('.monthly_plan_item');
        for (let i = 0; i < monthly_plans.length; i++) {
            monthly_plans[i].style.display = 'table-cell'
        }
        $('#show_more_plan_link').remove()
        // $('#ir_packs_parent_id').addClass('monthly-plan-scroll pl-10')
        // $('#ir_packs_parent_id').removeClass('monthly-plan-single pl-67')


    };

    if (!(chatItem &&
        chatItem.scenarioResponse &&
        chatItem.scenarioResponse.templateNameList &&
        chatItem.scenarioResponse.templateNameList.length > 0 &&
        chatItem.scenarioResponse.templateNameList[0].includes(globalConstants.Scenario_Template_List.IR_PACKS_RECO))) {
        setTimeout(() => {
            //  showMorePlans();
        })
    }


    const onProceed = (pack) => {
        IdleTimeoutService.updateIdleState();
        if (isSubscribedAnyPack) {
            handleAlreadySubscribedCase(pack);
        } else {
            handleNoSubscriptioncase(pack);
        }
    };


    const handleNoSubscriptioncase = (pack) => {

        showPopup(
            <ConfirmationBox
                title={'Subscribe New Pack'}
                messages={[`Validity & Rental of Rs. ${pack.price} would apply only when you reach the country covered under the pack. Are you sure you want to proceed?`,
                    `Note: Pack rental would not be charged while in India, also pack would be renewed in case of mobile usage abroad post pack validity.`]}
                buttons={[
                    {
                        label: 'No',
                        onClick: () => {

                            showPopup(undefined)
                            setBottomBarToInput()
                            UtilService.disableActivateIrCardLink()
                            if (chatItem && chatItem.scenarioResponse && chatItem.scenarioResponse.templateNameList) {
                                chatItem.scenarioResponse.templateNameList = [];
                            }
                            // {cancel_comp_set}
                            GlobalStoreService.set("components_handler", { ...GlobalStoreService.get('components_handler'), bottom_bar_comp: 'chat-bar-comp' });

                            // handleOptionsClick({option_params:{ ...chatItem,
                            //         option_selected:"No",
                            //         actionType: 'CHOICE_CLICKED'},
                            //         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')
                            //     })
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED, 'No'))
                        }
                    },
                    {
                        highlight: true,
                        label: 'Yes',
                        onClick: () => {
                            showPopup(undefined)
                            setBottomBarToInput()
                            UtilService.disableActivateIrCardLink()
                            // {cancel_comp_set}
                            GlobalStoreService.set("components_handler", { ...GlobalStoreService.get('components_handler'), bottom_bar_comp: 'chat-bar-comp' });
                            // handleOptionsClick({option_params:{ ...chatItem,
                            //         option_selected:pack.id,
                            //         pack:pack,
                            //         actionType: 'CHOICE_CLICKED'},
                            //         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to activate pack of Rs. ${pack.price}`)
                            //     })
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED, pack.id, null, null, `I want to activate pack of Rs. ${pack.price}`))


                        }
                    },

                ]} />)
    }

    const handleAlreadySubscribedCase = (pack) => {
        IdleTimeoutService.updateIdleState();
        showPopup(
            <ConfirmationBox
                title={'Subscribe New Pack'}
                messages={[`Validity & Rental of Rs. ${pack.price} would apply only when you reach the country covered under the pack. Are you sure you want to proceed?`,
                    `Note: Pack rental would not be charged while in India, also pack would be renewed in case of mobile usage abroad post pack validity.`]}
                buttons={[
                    {
                        label: 'No',
                        onClick: () => {
                            showPopup(undefined)
                            setBottomBarToInput()
                            UtilService.disableActivateIrCardLink()
                            if (chatItem && chatItem.scenarioResponse && chatItem.scenarioResponse.templateNameList) {
                                chatItem.scenarioResponse.templateNameList = [];
                            }

                            chatItem.scenarioResponse.templateNameList = [];
                            // handleOptionsClick({option_params:{ ...chatItem,
                            //         option_selected:"No",
                            //         actionType: 'CHOICE_CLICKED'},
                            //         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')})
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED, 'No'))
                        }
                    },
                    {
                        highlight: true,
                        label: 'Yes',
                        onClick: () => {
                            showPopup(undefined)
                            handleConfirmationForAlreadySubscribedCase(pack);

                        }
                    },

                ]} />
        )
    }

    const handleConfirmationForAlreadySubscribedCase = (pack) => {
        IdleTimeoutService.updateIdleState();
        showPopup(
            <ConfirmationBox
                title={'Subscribe New Pack'}
                messages={[`You have an existing pack ${subscribedPack.price}. In order to activate the ${pack.price} pack, we will deactivate the existing pack. Are you sure you want to continue?`]}
                buttons={[
                    {
                        label: 'No',
                        onClick: () => {
                            showPopup(undefined)
                            setBottomBarToInput()
                            UtilService.disableActivateIrCardLink()
                            if (chatItem && chatItem.scenarioResponse && chatItem.scenarioResponse.templateNameList) {
                                chatItem.scenarioResponse.templateNameList = [];
                            }
                            // handleOptionsClick({option_params:{ ...chatItem,
                            //         option_selected:"No",
                            //         actionType: 'CHOICE_CLICKED'},
                            //         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')})
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED, 'No'))
                        }
                    },
                    {
                        highlight: true,
                        label: 'Yes',
                        onClick: () => {
                            showPopup(undefined)
                            setBottomBarToInput()
                            UtilService.disableActivateIrCardLink()
                            // handleOptionsClick({option_params:{ ...chatItem,
                            //         option_selected:pack.id,
                            //         pack:pack,
                            //         actionType: 'CHOICE_CLICKED'},
                            //         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to activate pack of Rs. ${pack.price}`)})
                            handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED, pack.id, null, null, `I want to activate pack of Rs. ${pack.price}`))
                        }
                    },

                ]} />)

    }
    const showPackDetails = (pack) => {
        IdleTimeoutService.updateIdleState();
        showPopup(<PackBenefits pack={pack} showPopup={showPopup} />)
    }

    return (


        <div id={`plans_scroll_${messageTime.timestamp}`} style={{ alignItems: 'center', display: 'flex' }} className={`monthly-plan monthly-plan-scroll ${(templateName === 'IR_PACKS_ALL' && false && irPackList.length > 1) ? 'monthly-plan-scroll pl-10' : 'monthly-plan-single pl-67'}`} >
            {(UtilService.getPlatformType() === PlatformType.WEB) && <div >
                <div><button className="arrow_button_left"
                    onClick={() => {
                        UtilService.startScrollingLeft(`plans_scroll_${messageTime.timestamp}`)
                    }}
                >&#8249;</button></div>
                <div><button className="arrow_button_right"
                    onClick={() => {
                        UtilService.startScrollingRight(`plans_scroll_${messageTime.timestamp}`)
                    }}
                >&#8250;</button></div>
            </div>}
            {!irPackList && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_SYSTEM_INFO_MESSAGE}</p></li></ul>}
            <ul >{irPackList && irPackList.map((pack, index) => {
                return (
                    <li className="monthly_plan_item" style={{ display: ((templateName !== 'IR_PACKS_ALL') && irPackList.length > 1 && index !== 0) ? 'none' : '' }}>
                        <div className="plan-details color-black pos-rel">
                            {pack.suggested_pack && <span className="favorite"><img src={`${process.env.PUBLIC_URL}/assets/images/favorite.svg`} width="15" /></span>}
                            {pack.subscribed && pack.subscribed === "true" && <span className="active-plan"><img src={`${process.env.PUBLIC_URL}/assets/images/active-plan-new.png`} width="20" /></span>}
                            <span className="fs-8 display-block color-grey pl-10  pt-15" title={pack.validity && pack.validity}>{pack.validity && pack.validity.toString().length > 13 ? pack.validity.toString().substr(0, 13) + '...' : pack.validity}</span>
                            <span className="fs-20 display-block color-dark-grey  pl-10">Rs. {pack.price}<span className="fs-10 color-link cursor-pointer" onClick={() => { showPackDetails(pack) }}>&#9432;</span></span>
                            <span className="line" />
                            <ul className="benifits">
                                {pack.packBenefits && pack.packBenefits.map((benefit, index) => {
                                    if (index < 3) {
                                        return (
                                            <li>{benefit.quota} {benefit.label} {pack.packBenefits.length > 3 && index === 2 ? `+ ${pack.packBenefits.length - 3} more...` : ''}</li>
                                        )
                                    } else {
                                        return ""
                                    }
                                })}
                            </ul>
                            {
                                pack.subscribed === 'false' &&
                                <button
                                    disabled={(message.fromHistory) ? true : false}
                                    style={{ opacity: message.fromHistory ? 0.5 : 1 }}
                                    className="ir-card-links color-link fs-12 activate cursor-pointer"
                                    onClick={() => {
                                        onProceed(pack)
                                    }}>ACTIVATE</button>
                            }
                        </div>
                    </li>
                )
            })}
                {(templateName !== 'IR_PACKS_ALL') && irPackList.length > 1 &&
                    <li>
                        <div id="show_more_plan_link" className="plan-details link text-center width-auto cursor-pointer" onClick={() => { showMorePlans() }}>
                            <span className="more-packs text-center"><img src={`${process.env.PUBLIC_URL}/assets/images/packs-arrow.svg`} width="15"
                                className="pt-10" /></span>
                            <span className="fs-12 color-grey">MORE PACKS</span>
                        </div>
                    </li>}
            </ul>
        </div>
    );
}

export default IrRecommendedPacks;


// WEBPACK FOOTER //
// ./src/components/message-components/ir-packs-components/ir-recommended-packs.component.js